// extracted by mini-css-extract-plugin
export default {"modal":"p9AfCM","description":"a0wkQs","timer":"lhBugR","submit":"EPBT_0","resend":"MmXprx"};